module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pause-serve"
    }
  }, [_c('pause-serve-header'), _vm._v(" "), _c('div', {
    staticClass: "pc-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "zh-text"
  }, [_vm._v(_vm._s(_vm.pauseServeInfoZh))]), _vm._v(" "), _c('p', {
    staticClass: "en-text"
  }, [_vm._v(_vm._s(_vm.pauseServeInfoEn))])])]), _vm._v(" "), _c('div', {
    staticClass: "phone-container"
  }, [_c('p', [_vm._v(_vm._s(_vm.phone.sorryNoticeZh))]), _vm._v(" "), _c('p', {
    staticClass: "en-text higher-bottom"
  }, [_c('span', [_vm._v(_vm._s(_vm.phone.sorryNoticeEn))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phone.pauseServeZh))]), _vm._v(" "), _c('p', {
    staticClass: "en-text"
  }, [_vm._v(_vm._s(_vm.phone.pauseServeEn))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d57aa85c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pauseServe/Index.vue
// module id = 1395
// module chunks = 1